import sdl from '@jds/react-generated-sdl/JDSPagination';
import type { JDSPaginationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, PaginationProps } from '../logic';

const Component = (props: PaginationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'basic',
    previousButtonAriaLabel = 'Previous Page',
    nextButtonAriaLabel = 'Next Page',
    lastButtonAriaLabel = 'Last Page',
    firstButtonAriaLabel = 'First Page',
    ariaLabel = 'Pagination navigation',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      previousButtonAriaLabel,
      nextButtonAriaLabel,
      lastButtonAriaLabel,
      firstButtonAriaLabel,
      ariaLabel,
      ...rest
    },
    'JDSPagination',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Pagination = withLogic(Component) as React.FC<PaginationProps> & {
  slotName?: string;
};

Pagination.displayName = 'Pagination';
Pagination.slotName = 'jds_pagination';

export { Pagination, type JDSPaginationProps };
